import Rest from '../Rest';

export default class AreaService extends Rest {
	static resource = '/areas';
    
	async getAreasById(page, id, cities) {

        const filter = [{property:'provider',operator:'=',value:id,}];

        if (cities?.length) {

            filter.push({property:'cities',operator:'in',value:cities,})

        }

        return await this.get(`/personal?page=${page}&filter=${JSON.stringify(filter)}`);
            
    }

	async getAreasMap(page, id) {

        const filter = [{ property: 'provider', operator: '=', value:  id, }];
        
        const limit = 100

        return await this.get(`/map?page=${page}&sort=desc&limit=${limit}&filter=${JSON.stringify(filter)}`);
            
    }

    async uploadKM(km, id) {
	
		return await this.post('/km/' + id, km);
	
    }

    async save(areaData) {
		
		return await this.post(`/`, areaData);

    }

    async update(id, payload) {
		
		return await this.put(`/${id}`, payload);
	
    }

    async updateMany(payload) {
		
		return await this.put(`/`, { updateData: payload.areasToUpdate});
	
    }

    async updateMapEditedAreas(payload) {
		try {
			return await this.put(`/editedAreas/map`, payload);
		} catch(error) {
			console.log(error)
			throw new Error(error)
		}
    }

    async deleteAreas(areasId) {
	
		return await this.delete('/', { data: { areasId } });

    }
    async deleteArea(areaId) {
	
		return await this.delete(`/${areaId}`);

    }
    
	async hasMatchingAreas(lat, lng) {
		const filter = [
			{
				property: 'polygon',
				operator: 'point-intersect',
				value: { lat, lng },
			},
		];
		
		const data = await this.get(`?limit=1&filter=${JSON.stringify(filter)}`);
		
		return !!data.total && Math.random() > 0.5;
		// return !!data.total;
	}
}
